import React, {useCallback, useEffect} from 'react';
import {ThemeProvider} from '@mui/material';
import theme from './theme/materialTheme';
import {UserContext} from './auth/userContext';
import useIdToken from './auth/useIdToken';
import {auth} from './service/firebase';
import AppShell from './AppShell';
import * as Sentry from '@sentry/react';
import {ErrorBoundary} from '@sentry/react';
import {generateTrackingService} from './service/trackingTrigger';
import {sendEventToGA4} from './service/gtagHelpers';
import {generateUniqueTemplateKey} from './service/gtmHelpers';
import useGA4Dimensions from './hooks/useGA4Dimensions';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENVIRONMENT,
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  integrations: [],
});

function App() {
  const [user, fupaUser, isLoading, error] = useIdToken(auth);
  const pushGA4 = generateTrackingService();
  useGA4Dimensions();

  const pageViewEvent = useCallback(
    (pathname: string, search: string, hash: string) => {
      const page = pathname + search + hash;
      const {template} = generateUniqueTemplateKey(pathname);
      pushGA4({page_title: document.title, page_location: document.location, content_group: template}, page, (event) =>
        sendEventToGA4('page_view', event)
      );
    },
    [pushGA4]
  );

  useEffect(() => {
    pageViewEvent(document.location.pathname, document.location.search, document.location.hash);
  }, [pageViewEvent]);

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <UserContext.Provider value={{user, fupaUser, isLoading, error}}>
          <AppShell />
        </UserContext.Provider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
